import HorizontalSlideScroll from "./HorizontalSlideScroll";

export default HorizontalSlideScroll;